import { render, staticRenderFns } from "./th.vue?vue&type=template&id=42dc48f3&"
import script from "./th.vue?vue&type=script&lang=ts&"
export * from "./th.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports